// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"9b88e635","421":"0352a171","643":"d171bb06"}[chunkId] + ".chunk.js";
};